export default {
      id: "zoom_marker-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#zoom_marker",
      toString: function () {
        return this.url;
      }
    }